<!-- @Version 1.0.1 -->
<div class="row" data-testid="translate">
   <ng-content select="[special-list]"></ng-content>
   <ng-content select="[csv-list]"></ng-content>
   <ng-content select="[login-list]"></ng-content>
</div>